import { api } from "./dataService";

export const fetchDocumentCategoryMappings = async () => {
  return (await api.get("data/document-category-mappings")).data;
};

export const fetchUnmappedCategories = async () => {
  return (await api.get("data/document-category-mappings/unmapped-categories")).data;
};

export const createDocumentCategoryMapping = async (payload) => {
  return (await api.post("data/document-category-mappings", payload)).data;
};

export const updateDocumentCategoryMapping = async (mapping_id, payload) => {
  return (await api.patch(`data/document-category-mappings/${mapping_id}`, payload)).data;
};

export const deleteDocumentCategoryMapping = async (mapping_id) => {
  await api.delete(`data/document-category-mappings/${mapping_id}`);
};

export const reapplyDocumentCategoryMappings = async () => {
  return (await api.post("data/document-category-mappings/reapply")).data;
};
